import Layout from './layout.js';
import DistanceMap from './distanceMap.js';

class MaxDistanceLayout extends Layout {
    constructor() {
        super();

        this._labels = new Map();
        this._mask = null;
        this._distanceMap = null;

        this._pointFound = new Set();
    }

    addLabel(id) {
        if (this._labels.has(id)) {
            throw new Error('already added');
        }

        this._labels.set(id, { pointPosition: null });
    }

    removeLabel(id) {
        if (!this._labels.has(id)) {
            throw new Error('not added');
        }

        this._labels.delete(id);
    }

    setLabel(id, newData) {
        if (!this._labels.has(id)) {
            throw new Error('not added');
        }

        if ('pointPosition' in newData) {
            let { pointPosition } = newData;
            if (pointPosition) {
                pointPosition = { x: pointPosition.x, y: pointPosition.y };
            }

            let data = this._labels.get(id);
            data.pointPosition = pointPosition;
        }
    }

    setMask(mask) {
        this._mask = mask;

        if (mask) {
            if (this._distanceMap === null) {
                this._distanceMap = new DistanceMap();
            }

            this._distanceMap.calculate(mask);
        } else {
            this._distanceMap = null;
        }
    }

    getLabel(id) {
        let data = this._labels.get(id);

        if (!data || data.pointPosition === null) {
            return null;
        }

        return data;
    }

    update(useMask) {
        if (!useMask) {
            return;
        }

        if (this._mask === null) {
            for (let [id, data] of this._labels) {
                data.pointPosition = null;
            }

            return;
        }

        const { width, height } = this._mask;
        const getAtPos = this._mask.makeGetterAtPos();

        const distanceData = this._distanceMap.data;
        const maxDistance = this._distanceMap.maxDistance;

        let pos = 0, size = width*height;
        for (let pos = 0; pos < size; pos++) {
            let id = getAtPos(pos);
            if (this._labels.has(id) && !this._pointFound.has(id) && distanceData[pos] === maxDistance.get(id)) {
                let labelData = this._labels.get(id);
                let x = pos%width, y = Math.floor(pos/width);

                if (labelData.pointPosition === null) {
                    labelData.pointPosition = { x, y };
                } else {
                    labelData.pointPosition.x = x;
                    labelData.pointPosition.y = y;
                }

                this._pointFound.add(id);
            }
        }

        for (let [id, data] of this._labels) {
            if (!this._pointFound.has(id)) {
                data.pointPosition = null;
            }
        }

        this._pointFound.clear();
    }

    // debug
    generateDistanceImageData() {
        return this._distanceMap.generateImageData();
    }
}

export default MaxDistanceLayout;
